module.exports = __webpack_public_path__ + "c20b5b7362d8d7bb7eddf94344ace33e.woff2";